import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App.js';
import { store } from './stores/mainStore';
import * as serviceWorker from './serviceWorker';
import { i18nReady, i18n } from './i18n';

//localStorage.clear();

window.gtag('event', 'logic-loaded', { event_label: 'timing', start: window.startTime, end: Date.now() });

const config = window.dodConfig;
config.isLandscape = false; // config.orientation === 'landscape';

window.setPersistentStorage = function (key, value) {
	try {
		value = value.toString();
		console.log(' --> save to local storage :: k =', key, 'v =', value);
		localStorage.setItem(key, value);
	} catch (error) {
		console.warn('wrapper storage error' + error);
	}
};

window.restartWebview = function () {
	localStorage.setItem('restart', 'yes');
	window.location.reload();
};

window.addEventListener('resize', () =>  store.recalcAspectRatio());
window.addEventListener('orientationchange', () => store.recalcAspectRatio());

window.commands = [];
window.WrapperApp = {
	postMessage: (message) => {
		if(message.startsWith('open-url')) {
			window.open('https://'+ message.split('=')[1])
		} else if (!(store.isDev || window.location.hash === "#dev")) {
			/* if (store.wrapperCommandProcessing === false) {
				store.wrapperCommandProcessing = true;
				// window.location.href = "uniwebview://" + message;
			} else { */
				window.commands.push(message);
			//}
		}
	},
};

//internationalization
i18nReady.then(() => {
	console.log('i18next', i18n.language);
	window.rawLang = i18n.language;
	const supportedLanguages = ['en'];
	//if the settings have never been changed, use the detected language
	if (!localStorage.getItem('settings') || supportedLanguages.indexOf(store.settings.language) === -1) {
		var lang = 'en';

		if(window.rawLang === 'pt-BR') {
			lang = 'br';
			store.changeSetting('language', lang);
		} else {
			var i18nLang = i18n.language.split('-')[0];
			if (supportedLanguages.indexOf(i18nLang) > -1) {
				lang = i18nLang;
			}
			lang = store.fixUpLanguage(lang);	//fix for MX
			i18n.changeLanguage(lang).then(() => {
				store.changeSetting('language', lang);
			});	
		}
	}
}).catch(err => console.error('i18n error', err));

document.body.removeChild(document.getElementById('loadMsg'));
i18nReady.then(() => {
	ReactDOM.render(<App />, document.getElementById('root'));
})
.catch(() => {
	window.location.reload();
});

serviceWorker.unregister();
